export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8806.559d3f0a.jpg";